import type { CropType } from "@/api/model/crop-type";
import type { Nutrient } from "@/api/model/nutrient";
import { atom } from "jotai";
import { apiService } from "@/api/service";
import { withOperationHandlingAtom } from "../operations";

const nutrientsDataAtom = atom<Nutrient[]>([]);
nutrientsDataAtom.debugLabel = "nutrientsDataAtom";

const cropTypesDataAtom = atom<CropType[]>([]);
cropTypesDataAtom.debugLabel = "cropTypesDataAtom";

export const nutrientsAtom = atom((get) => get(nutrientsDataAtom));
nutrientsAtom.debugLabel = "nutrientsAtom";

export const cropTypesAtom = atom((get) => get(cropTypesDataAtom));
cropTypesAtom.debugLabel = "cropTypesAtom";

export const fetchReferenceDataAtom = atom(null, async (get, set) => {
  const result = await set(
    withOperationHandlingAtom,
    {
      operation: "fetchReferenceData",
      message: "Carregando dados de referência...",
      displayLoading: true,
      displayError: true,
    },
    async () => {
      const [nutrients, cropTypes] = await Promise.all([
        apiService.nutrient.query({ fields: ["*"] }),
        apiService.cropType.query({ fields: ["*"] }),
      ]);
      set(nutrientsDataAtom, nutrients);
      set(cropTypesDataAtom, cropTypes);
      return { nutrients, cropTypes };
    }
  );
  return result;
});
fetchReferenceDataAtom.debugLabel = "fetchReferenceDataAtom";
